<template>
  <div class="basicControls" v-if='showSelf' :style="panelStyle">
      <div class="basicControls-title">模拟驾驶</div>
      <div class="panel-car">
            <div class="panel-car-top">
                 <span class="car-item-small" @click="slowNav">
                     <i class="iconfont icon-jiansu-"></i>
                 </span>
                 <span class="car-item-small" @click='playNav'>
                     <i class="iconfont icon-kaishi-" v-if="player=='play'"></i>
                     <i class="iconfont icon-zanting-" v-if="player=='pause'"></i>
                 </span>
                 <span class="car-item-small" @click='acceNav'>
                     <span class="iconfont icon-qianjin"></span>
                 </span>
                 <span class="car-item-small" @click='stopNav'>
                     <i class="iconfont icon-tingzhi"></i>
                 </span>
                 <div class="car-item-big speed">
                    {{carSpeed}}
                 </div>
            </div>
            <div class="panel-car-top">
                 <div class="car-item-small car-view" @click="switchCamera">
                    <i class="iconfont icon-moxing" v-if="inCar=='notInCar'"></i>
                    <i class="iconfont icon-ehl_jiashiren" v-if="inCar=='inCar'"></i>
                 </div>
            </div>
            <!-- <div class="panel-bottom" @click="">
                 退出模拟驾驶
            </div> -->
        </div>
  </div>
</template>
<script>
   import {NavControllCommand} from './commands/NavControllCommand.js'
export default {
  data: function() {
    return {
      carSpeed:80,
      showSelf:false,
      inCar:'notInCar',
      player:'play',
      panelStyle: 'top:70px;right:15px;', 
      playIcon: '/static/bimroad/imgs/player_play.png'
    }
  },
  methods: {
    adjStyle : function(style){
        this.panelStyle=  style;
   },

    //0-stop 1-playOrResume 2-acc 3-deacce
    stopNav(){
        var eventArg = {'command': new NavControllCommand(0, this)};
        this.$emit("controlNavCommand", eventArg);
    },
    playNav(){
      var eventArg = {'command': new NavControllCommand(1, this)};
      this.$emit("controlNavCommand", eventArg);
    },
    slowNav(){
      var eventArg = {'command': new NavControllCommand(3, this)};
      this.$emit("controlNavCommand", eventArg);
    },
    acceNav(){
      var eventArg = {'command': new NavControllCommand(2, this)};
      this.$emit("controlNavCommand", eventArg);
    },
    switchCamera(){
      var eventArg = {'command': new NavControllCommand(4, this)};
      this.$emit("controlNavCommand", eventArg);
    },
    resetCarSpeed(){
       this.carSpeed=80;
    }
  }
}
</script>
<style lang='less' scoped>
    @import '../../assets/css/mixin.less';
       .basicControls{
          position:absolute;
          width:248px;
          box-sizing: border-box;
          border: 1px solid #14171c;
          background: linear-gradient(0deg,#1e202a,#0d1013);
          box-shadow: inset 0 0 0 1px #575757, 0 2px 21px 0 rgba(33,34,39,.55);
          opacity: .85;
          border-radius: 2px;
          z-index:200;
         .sc(14px,#fff);
        .basicControls-title{
          .wh(100%,40px);
          line-height:40px;
          text-align: center;
          border-bottom:1px dotted #505050;
        }
       .panel-car{
            width:248px;
            .panel-car-top{
                padding:9px 13px;
                display:flex;
                align-items:center;
                .car-item-small{
                   .wh(30px,30px);
                   background-color: #fff;
                   display:flex;
                   align-items:center;
                   justify-content:center;
                   margin-right:13px;
                   border-radius:50%;
                   cursor:pointer;
                   color:#51515d;
                   &:hover{
                      color:#3970F0;
                   }
                   .icon-qianjin{
                      font-size:14px;
                      margin-left:2px;
                   }
                   .icon-kaishi-{
                      font-size:18px;
                      margin-left:-3px;
                   }
                   .icon-jiansu-{
                      margin-right:2px;
                   }
                }
                .car-item-big{
                    .wh(40px,40px);
                    background-color: #fff;
                   display:flex;
                   align-items:center;
                   justify-content:center;
                   
                   border-radius:50%;
                   
                   color:#51515d;
                }
                .speed{
                    background-size:cover;
                    background-repeat:no-repeat;
                    background-position:center center;
                    background-image:url('/static/bimroad/imgs/Speedcard.png');
                }
                .car-view{
                    cursor:pointer;
                    margin-right:13px;
                    &:hover{
                      color:#3970F0;
                    }
                    .icon-moxing{
                        font-size:20px;
                    }
                }
            }
            .panel-bottom{
                .wh(100%,35px);
                line-height:35px;
                .sc(14px,#fff);
                text-align: center;
                border-top:1px solid #696d80;
                cursor:pointer;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/plugins/components/Web3dModels/NavControlPanel.vue